import React, { useEffect, useState } from 'react';
import axios from 'axios';
const Filter = () => {
  const [data, setData] = useState([]);

  const getdata = async () => {
    const res = await axios.get(
      'https://portfolio-node-7hlx.onrender.com/getfilter'
    );
    setData(res.data);
  };
  useEffect(() => {
    getdata();
  }, []);
  return (
    <>
      <div className="filter">
        <h3 className="text-center p-3">My Projects</h3>
        <br />
        <div className="container">
          <div className="row mt-5">
            {data?.map((val, ind) => {
              return (
                <>
                  <div
                    className="col-lg-4 col-md-4 col-sm-6 col-12  mb-5"
                    key={ind}
                  >
                    <a href={val.link} target="_blank" rel="noreferrer">
                      <div className="card">
                        <img src={val.image} alt="" className="filterimg" />
                      </div>
                    </a>
                  </div>
                </>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default Filter;
